import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconModified } from 'src/assets/icons/Modified';
import { CustomIconButton } from 'src/components/CustomIconButton';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { TruncatedTypography } from 'src/components/TruncatedTypography';
import { useEffectOnce } from 'src/lib/hooks';

import { InsightBox } from '../InsightBox';

import { DisabledBanner } from './components/DisabledBanner';
import { StyleGuideItem } from './components/StyleGuideItem';
import { SuccessMessage } from './components/SuccessMessage';
import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  violations: PropTypes.array,
  onSettingsClick: PropTypes.func.isRequired,
  onFixAllClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  apStyleGuidelinesEnabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  onMounted: PropTypes.func.isRequired,
};

const defaultProps = {
  className: null,
  classes: null,
  violations: [],
  loading: false,
  apStyleGuidelinesEnabled: false,
  readOnly: false,
};

export const StyleGuide = ({
  className,
  classes,
  violations,
  onSettingsClick,
  onFixAllClick,
  loading,
  apStyleGuidelinesEnabled,
  readOnly,
  onMounted,
}) => {
  const styles = useStyles({ classes });

  const hasDetectedViolations = violations.length > 0;

  useEffectOnce(() => {
    onMounted();
  });

  return (
    <div
      className={cx(styles.root, className)}
      data-section="style-guide"
    >
      <div className={styles.header}>
        <TruncatedTypography
          className={styles.boxGroupTitle}
          variant={TYPOGRAPHY_VARIANT.medium12}
        >
          Format: AP style guide
        </TruncatedTypography>

        {onSettingsClick && (
          <CustomIconButton
            className={styles.buttonSettings}
            onClick={onSettingsClick}
          >
            <IconModified />
          </CustomIconButton>
        )}
      </div>
      <InsightBox
        className={styles.wrapper}
        loading={loading}
        onSettingsClick={onSettingsClick}
      >
        {!apStyleGuidelinesEnabled ? (
          <DisabledBanner onCtaClick={onSettingsClick} />
        ) : hasDetectedViolations ? (
          <StyleGuideItem
            violations={violations}
            loading={loading}
            onFixAllClick={onFixAllClick}
            readOnly={readOnly}
          />
        ) : (
          <SuccessMessage />
        )}
      </InsightBox>
      {loading && (
        <CustomTypography
          className={styles.loadingLabel}
          variant={TYPOGRAPHY_VARIANT.regular12}
        >
          Analyzing text for AP style compliance, this might take a few seconds...
        </CustomTypography>
      )}
    </div>
  );
};

StyleGuide.propTypes = propTypes;
StyleGuide.defaultProps = defaultProps;
